var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3750 3750",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#353741",
      stroke: "#000",
      strokeWidth: "12.5px"
    },
    d: "M-63.599-164.469h4104.82v4283.75H-63.599z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M918.321 917.627h1913.84v1582.81s-471.333-557.026-691.75-104.406l-918.804-774.216-303.935 313.871.653-1018.06Z",
    style: {
      fill: "#a24545",
      fillOpacity: 0,
      stroke: "#62dea7",
      strokeWidth: "62.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a24545",
      fillOpacity: 0,
      stroke: "#62dea7",
      strokeWidth: "62.5px"
    },
    d: "M710.33 710.33h2329.34v2329.34H710.33z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2333.06,
    cy: 1444.16,
    r: 220.308,
    style: {
      fill: "#a24545",
      fillOpacity: 0,
      stroke: "#62dea7",
      strokeWidth: "62.5px"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image-placeholder.30ec2842f9703ff6964e9d87bbc4ed8c.svg";
export { ForwardRef as ReactComponent };